import React from 'react';

import { appNamedRoutes } from 'routes';

import PageSubNav from 'components/nav/PageSubNav';

const GROUP_AND_COHORT_PAGES = [
  {
    path: appNamedRoutes.groupcohortsReportGeneral,
    label: 'General',
  },
  {
    path: appNamedRoutes.groupcohortsReportOrganizationType,
    label: 'Grouped by Organization Type',
  },
];


const GroupCohortsSubNav = () => {
  return (
    <PageSubNav items={GROUP_AND_COHORT_PAGES} />
  );
};

export default GroupCohortsSubNav;
